import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Shield, Award, Clock, Hammer } from 'lucide-react';

const badges = [
  { icon: Shield, value: '5 ani', label: 'Garanție' },
  { icon: Award, value: '15+', label: 'Ani experiență' },
  { icon: Hammer, value: '500+', label: 'Proiecte finalizate' },
  { icon: Clock, value: '100%', label: 'Livrare la timp' },
];

export default function TrustBadges() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-40px' });

  return (
    <section data-testid="trust-badges" className="relative z-10 -mt-4 pb-8">
      <div className="max-w-5xl mx-auto px-6 lg:px-12">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="bg-white dark:bg-[#242322] rounded-2xl shadow-xl border border-[#E3DACB] dark:border-[#3D3A37] p-6 lg:p-8"
        >
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
            {badges.map((badge, i) => {
              const Icon = badge.icon;
              return (
                <motion.div
                  key={badge.label}
                  initial={{ opacity: 0, y: 20 }}
                  animate={isInView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.5, delay: 0.1 + i * 0.1 }}
                  data-testid={`trust-badge-${i}`}
                  className="flex items-center gap-4"
                >
                  <div className="w-12 h-12 rounded-xl bg-[#A67B5B]/10 dark:bg-[#A67B5B]/20 flex items-center justify-center flex-shrink-0">
                    <Icon size={22} className="text-[#A67B5B]" />
                  </div>
                  <div>
                    <p className="font-['Outfit'] text-xl font-semibold text-[#2C2A29] dark:text-[#F0EDE8]">{badge.value}</p>
                    <p className="text-xs text-[#6B6561] dark:text-[#9B9590]">{badge.label}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
